import React from 'react';
import { Card } from '../../../components/ui/Card';

const ProgressBar: React.FC<{ value: number; max: number }> = ({ value, max }) => {
    const isInfinite = max === Infinity || max === 0;
    const percentage = !isInfinite ? Math.min((value / max) * 100, 100) : 0;
    const isFull = !isInfinite && value >= max;
    const isNearFull = !isInfinite && percentage >= 80 && !isFull;

    const fillClass = isFull
        ? 'progress-fill--danger'
        : isNearFull
            ? 'progress-fill--warning'
            : '';

    const textColor = isFull
        ? 'text-error font-semibold'
        : isNearFull
            ? 'text-warning'
            : 'text-muted';

    return (
        <div>
            {!isInfinite && (
                <div className="progress-wrap progress-lg">
                    <div
                        className={`progress-fill ${fillClass}`.trim()}
                        style={{ width: `${percentage}%` }}
                    />
                </div>
            )}
            <p className={`text-2xs mt-s2 ${textColor}`}>
                {value} usado de {isInfinite ? 'Ilimitado' : max}
                {!isInfinite && ` | ${percentage.toFixed(0)}%`}
                {isFull && ' — Limite atingido'}
            </p>
        </div>
    );
};

const UsageCard: React.FC<{ title: string; used: number; total: number; }> = ({ title, used, total }) => (
    <Card>
        <Card.Header className="pb-4">
            <Card.Title className="text-section-title">{title}</Card.Title>
        </Card.Header>
        <Card.Content className="pt-0">
            <ProgressBar value={used} max={total} />
        </Card.Content>
    </Card>
);

export default UsageCard;
